import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

const PILL_STYLE = {
    width: 'fit-content',
    borderRadius: '99px',
    padding: '0.4rem 1.2rem',
    fontSize: '1.2rem',
    fontWeight: '600',
    lineHeight: '1.6rem'
};

const NEUTRAL_PILL = { background: '#F2F2F2', color: '#4F4F4F' };

const STATUS_PILLS = {
    Active: { i18nKey: 'policies.activeStatus', background: '#F2FFF6', color: '#1F6D51' },
    Expired: { i18nKey: 'policies.expiredStatus', ...NEUTRAL_PILL }
};


const PolicyStatusPill = ({ status }) => {
    const { t } = useTranslation();
    const pill = STATUS_PILLS[status];

    if (!pill) {
        if (!status) return 'N/A';
        return <Box sx={{ ...PILL_STYLE, ...NEUTRAL_PILL }}>{status}</Box>;
    }

    return (
        <Box sx={{ ...PILL_STYLE, background: pill.background, color: pill.color }}>
            {t(pill.i18nKey)}
        </Box>
    );
};

PolicyStatusPill.propTypes = {
    status: PropTypes.string
};

export default PolicyStatusPill;
